export enum KIOverlaySelectors {
    CHOOSE_STYLE = ".overlay-ki-stilrichtung",
    ENTER_PROMPT = ".overlay-ki-prompt",
    LOADING = ".overlay-ki-loading",
    RESULT = ".overlay-ki-result",
    ADDING_TO_LIBRARY = ".overlay-ki-addingtolibrary"
}

export function showKI_Image_Overlay(overlay: KIOverlaySelectors) {
    for (const o in KIOverlaySelectors) {
        if (KIOverlaySelectors[o] === overlay) {
            document.querySelector(KIOverlaySelectors[o]).classList.add("active");
        } else {
            document.querySelector(KIOverlaySelectors[o]).classList.remove("active");
        }
    }
}

export function closeAllKI_Image_Overlays() {
    for (const o in KIOverlaySelectors) {
        document.querySelector(KIOverlaySelectors[o]).classList.remove("active");
    }
}
